import { createAction } from 'redux-actions';

import { Actions } from '../constants';

export default createAction(Actions.REALTIME_CONNECTION_UPDATED);
